export default (props, vars) => props?.['applicationStatus']?.all_steps;
